import { createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { IdNamePair } from '../../@models/index';
import { Injectable, Injector } from '@angular/core';
import { ContactService } from '../../@services/contacts.service';
import { DropdownService } from '../../@services';
import { ENDPOINTS } from 'src/app/@config/endpoints';

@State<IdNamePair[]>({
  name: 'eventTypes',
  defaults: []
})
@Injectable()
export class EventTypesState {

  private static service: DropdownService

  static hasAny() {
    return createSelector([EventTypesState], (state: IdNamePair[]) => {
      return state.length > 0;
    });
  }

  static getEventName(id: number) {
    return createSelector([EventTypesState], (state: IdNamePair[]) => {
      return state.find((event: IdNamePair) => event.id === id).name;
    });
  }

  constructor(injector: Injector) {
    EventTypesState.service = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<EventTypesState>) {
    this.service.getDropdownData(ENDPOINTS.getEventTypeList()).subscribe(
      (data: IdNamePair[]) => {
        setState(data);
      }
    );
  }

}
